import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvServiceEditorV2.html?raw';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { EvService_Types, MainCatalogs_Classes, MainCatalogTypes } from "../../_loadingHelpers/MainCatalogTypes";
import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import MultiselectBox from '../../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import HintBox from '../../../moreCore/UI/HintBox/HintBox';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import { ExpandableSection, ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import { SelectEntityDialogTypes } from "../../../moreCore/_loadingHelpers/SelectEntityDialog";
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';




interface EvServiceCategoryEntry {
    categoryID: string;
    categoryColor: more.EntityAPIColor;
    assignmentID: string;
    description: string;
    isMainCategory: boolean;
    isDeleted?: boolean;
    blobNode?: HTMLElement;
    blobIcon?: HTMLElement;
}
interface PhysicalResourceEntry {
    resourceID: string;
    coloration: more.EntityAPIColor;
    assignmentID: string;
    code: string;
    description: string;
    limit: number;
    quantity: number;
    ref_resource_main_group: {
        description: string
    };
    isDeleted?: boolean;
}
interface PhysicalResourceData {
    ID: string;
    code: string;
    description: string;
    quantity: number;
    ref_resource_main_group: {
        ID: string;
        description: string
    };
    coloration: more.EntityAPIColor;
}
class EvServiceEditorV2 extends compose(MainCatalogsEditorBaseV2, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    input_Category: MdsLax<InstanceType<typeof MultiselectBox>>;
    input_Type: MdsLax<InstanceType<typeof SelectBox>>
    sectionTypeDefault: HTMLDivElement;
    categoriesContainer: HTMLElement;
    maincategoryContainer: HTMLElement;
    input_Price: MdsLax<InstanceType<typeof NumberInput>>;
    inputCategoriesContainer: HTMLElement;
    input_Unit: MdsLax<InstanceType<typeof SelectBox>>;


    private selectedCategories: Array<EvServiceCategoryEntry> = [];
    private selectedResources: Array<PhysicalResourceEntry> = [];
    private inputPhysicalResources: MdsLax<InstanceType<typeof HintBox>>;
    private resourcesTable: MdsLax<InstanceType<typeof StaticTable>> = null;
    private tableContainer: HTMLElement;
    private expanderPhysicalResources: MdsLax<InstanceType<typeof ExpandableSection>>;

    isValid(): boolean {
        //Need to implement
        return true;
    }

    protected beforeDelete() {
        let positions = this.getAttributeValue("EL_vt_positions_service");
        if (positions && positions.length > 0) {
            this.showToast(this.translate("EvServiceEditor_Error_NoDelete"), "fas fa-excalamation-triangle");
            return;
        }
        super.beforeDelete.apply(this, arguments as any);
    }

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        this._setInputTypeVisibility();


        this.selectedCategories = lang.clone(this.getAttributeValue("categories"));
        this.selectedResources = lang.clone(this.getAttributeValue("physicalResources"));

        this.loadReferenceCatalogs();



    }

    protected _onChanged(attribute: string, value: any) {
        switch (attribute) {
            case "service_type":

                break;
        }
    }

    private _onChangeInput_Categories(newValues: Array<string>) {



        let entityValues = lang.clone(this.input_Category.getValue(true));

        let labelProp = this.input_Category.labelAttribute;
        let valueProp = this.input_Category.valueAttribute;

        let missingCategories: Array<string> = [];
        let alreadySelectedCategories: Array<string> = (<Array<EvServiceCategoryEntry>>this.selectedCategories).map(function (assignment) {
            return assignment.categoryID;
        });

        let newAssignmentArray: Array<EvServiceCategoryEntry> = [];

        //for (let index = 0; index < this.selectedCategories.length; index++) {
        //    let categoryAssignment: EvServiceCategoryEntry = this.selectedCategories[index];

        //    if (categoryAssignment.assignmentID) {
        //        categoryAssignment.isDeleted = newValues.indexOf(categoryAssignment.categoryID, 0) == -1;
        //    } 

        //    newAssignmentArray.push(categoryAssignment);
        //}

        this.selectedCategories.forEach(categoryAssignment => {

            if (categoryAssignment.assignmentID) {

                categoryAssignment.isDeleted = newValues.indexOf(categoryAssignment.categoryID) == -1;
            }

            if ((newValues.length > 0 && newValues.indexOf(categoryAssignment.categoryID) > -1) || categoryAssignment.isDeleted !== undefined) {

                newAssignmentArray.push(categoryAssignment);
            }
        });

        for (let entity of entityValues) {
            if (alreadySelectedCategories.indexOf(entity[valueProp]) == -1) { // bisher noch nicht zugeordnet - neuer Eintrag!
                newAssignmentArray.push({
                    assignmentID: null,
                    categoryID: entity[valueProp],
                    categoryColor: entity.coloration,
                    description: entity[labelProp],
                    isMainCategory: newAssignmentArray.length == 0
                });
            }
        }

        //this.formData.categories = newAssignmentArray;
        this.selectedCategories = newAssignmentArray;
        this.setAttributeValue("categories", lang.clone(this.selectedCategories));

        this.drawSelectedCategoryBlobs();
    }

    private addCategoryBlob(categoryAssignment: EvServiceCategoryEntry) {

        let blob = this.UiModder.domConstruct.create("div", {
            className: "flex_row_center round nowrap border",
            order: 100
        }, categoryAssignment.isMainCategory ? this.maincategoryContainer : this.categoriesContainer);

        let blobX = this.UiModder.domConstruct.create("button", {
            className: "mds-button-base mds-hover-dark warningTXT round",
            innerHTML: "<i class='fas fa-times'></i>"
        }, blob);
        on(blobX, "click", lang.hitch(this, this._onClick_RemoveCategory, categoryAssignment));

        let blobMainSwitch = this.UiModder.domConstruct.create("div", {
            className: "", //"mds-button-base mds-hover-dark transparent",
            innerHTML: ""
        }, blob);
        let blobMainSwitchIcon = this.createFontawesomeIcon("fas fa-star w3-small paddingSmall", "", blobMainSwitch);

        //on(blobMainSwitch, "click", lang.hitch(this, this._onClick_MainCategory, categoryAssignment, !categoryAssignment.isMainCategory))

        // Hauptkategorie? 
        this.UiModder.domClass.toggle(blobMainSwitchIcon, "w3-hide", !categoryAssignment.isMainCategory); // regular: wenn es nicht maincategory ist
        //this.UiModder.domClass.toggle(blob, "bold darkBorder", categoryAssignment.isMainCategory);

        // gelöscht?
        this.UiModder.domClass.toggle(blob, "strike w3-disabled", categoryAssignment.isDeleted === true);

        let blobLabel = this.UiModder.domConstruct.create("div", {
            className: "paddingSmall",
            innerHTML: categoryAssignment.description
        }, blob);

        if (!categoryAssignment.isMainCategory) {
            this.UiModder.domClass.toggle(blobLabel, "mds-hover-dark", true);// !categoryAssignment.isMainCategory);
            on(blobLabel, "click", lang.hitch(this, this._onClick_MainCategory, categoryAssignment, true));
        }


        if (categoryAssignment.categoryColor) {
            let colorHexBG = categoryAssignment.categoryColor.BackColor?.Hex;
            let colorHexTXT = categoryAssignment.categoryColor.TextColor?.Hex;

            if (colorHexBG) {
                this.UiModder.domStyle.set(blob, "backgroundColor", colorHexBG);
            }

            if (colorHexTXT) {
                this.UiModder.domStyle.set(blobLabel, "color", colorHexTXT);
            }
        }
    }

    private drawSelectedCategoryBlobs(data?: Array<EvServiceCategoryEntry>) {

        if (!data) {
            data = this.getAttributeValue("categories");
        }

        this.UiModder.domConstruct.empty(this.categoriesContainer);
        this.UiModder.domConstruct.empty(this.maincategoryContainer);

        let categoryIds: Array<string> = [];

        if (data) {
            for (let assignedCategory of data) {
                // wir benötigen:
                // categoryIds (nicht assignment) für das Searchselect, damit die dort vorausgewählt sind
                // und wir erstellen die Blobs für schnellere Übersicht

                if (!assignedCategory.isDeleted) {
                    categoryIds.push(assignedCategory.categoryID);
                }

                this.addCategoryBlob(
                    assignedCategory
                );
            }
        }
    }

    private _onClick_RemoveCategory(targetAssignment: EvServiceCategoryEntry) {

        let selectedIDs: Array<string> = [];

        //for (let index = 0; index < this.selectedCategories.length; index++) {
        //    let categoryAssignment: EvServiceCategoryEntry = this.selectedCategories[index];

        //    if (categoryAssignment.categoryID == targetAssignment.categoryID) {
        //        if (categoryAssignment.assignmentID) {
        //            categoryAssignment.isDeleted = true;
        //        } else {
        //            this.selectedCategories.splice(index, 1);
        //        }
        //    } else {
        //        selectedIDs.push(categoryAssignment.categoryID);
        //    }
        //}

        let deletedCategory = this.selectedCategories.filter(x => x.categoryID === targetAssignment.categoryID)[0];

        deletedCategory.assignmentID ? deletedCategory.isDeleted = true : this.selectedCategories.splice(this.selectedCategories.indexOf(deletedCategory), 1);

        this.selectedCategories.forEach(categoryAssignment => {

            if (categoryAssignment.isDeleted !== true) selectedIDs.push(categoryAssignment.categoryID);
        });

        this.input_Category.setValue(selectedIDs);
    }

    private _onClick_MainCategory(assignment: EvServiceCategoryEntry, targetState: boolean) {

        for (let categoryAssignment of <Array<EvServiceCategoryEntry>>this.selectedCategories) {
            categoryAssignment.isMainCategory = false;

            if (categoryAssignment.categoryID == assignment.categoryID) {
                categoryAssignment.isMainCategory = true;
            }
        }

        this.setAttributeValue("categories", lang.clone(this.selectedCategories));

        this.drawSelectedCategoryBlobs();
    }

    private _setInputTypeVisibility(): void {
        var serviceType = this.input_Type.getValue();

        switch (serviceType) {
            case 1:
                this.UiModder.domClass.toggle(this.sectionTypeDefault, "w3-hide w3-disabled", false);
                break;
            case 4:
                this.UiModder.domClass.toggle(this.sectionTypeDefault, "w3-hide w3-disabled", true);
                break;
        }
    }

    private loadReferenceCatalogs(): void {
        let data = { "entityClass": this.entityClass, "ID": this.entityId };
        let requestUrl = window.appRoot + "MainCatalogsEditor/GetEvServiceCatalogs";
        //this.StandbyStart();
        this.UiModder.domClass.add(this.inputCategoriesContainer, "egoAnimated_fadingHourglassOverlay w3-disabled");

        this.RequestManager.post(
            requestUrl,
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, this._onLoadReferenceCatalogsResult),
            lang.hitch(this, this._onLoadReferenceCatalogsError),
            false // sync
        );
    }

    private _onLoadReferenceCatalogsResult(data: any) {

        let categoriesPreset: Array<string> = [];
        let alreadySelectedCategories = (<Array<EvServiceCategoryEntry>>this.selectedCategories).map(function (assignment) {
            return assignment.categoryID;
        });

        if (alreadySelectedCategories.length > 0) categoriesPreset = alreadySelectedCategories;
        else categoriesPreset = this.input_Category.getValue();

        this.input_Category.setData(categoriesPreset, data.serviceCategories, false);

        var unit = this.getAttributeValue("ref_service_unit");

        if (unit) {
            this.input_Unit.setData(unit.ID, data.serviceUnits, "ID", "description", true);
        } else {
            this.input_Unit.setData(null, data.serviceUnits, "ID", "description", true);
        }
        //    this.input_TaskDescript.setData(null, data.dutyTypes, "ID", "description", true);

        this.UiModder.domClass.remove(this.inputCategoriesContainer, "egoAnimated_fadingHourglassOverlay w3-disabled");

        this.resetDirty();
    }
    private _onLoadReferenceCatalogsError(error: more.requestErrorMessage) {

        alert("error loading catalogs!\r\n" + error.Message)
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.EvServices;
    }
    private _onClick_OpenEvServicesSED(evt) {
        this.loadSelectEntityDialog(evt,
            "selectPhysicalResources",
            lang.hitch(this, this._onCallback_Dlg)
        );
    }
    private _onCallback_Dlg(mode: string, data, items: Array<SelectEntityDialogTypes.Item<PhysicalResourceData>>) {
        // fake-entity falls das zurückgeleiferte Entity aus items[0].entry.data nicht dem entspricht das die liste erwartet

        if (!items || !items.length) return;
        if (mode == "selectPhysicalResources") {
            for (let item of items) {

                let entity: Partial<PhysicalResourceData> = item.entry?.data;

                if (!entity) {
                    entity = {
                        ID: item.entry.value, description: item.entry.label
                    };
                }

                this.addNewEntry(entity as any);
            }
        }
    }
    private setPhysicalResourceQuantity(row: StaticTable.StaticTableRow<PhysicalResourceEntry>, rowGroup: StaticTable.StaticTableRowGroup<PhysicalResourceEntry>): void {

        let dlg = new GenericDialog();
        let resource = rowGroup.entity;

        let content = this.UiModder.domConstruct.create("div");
        this.UiModder.domConstruct.create("p", {
            innerHTML: `${this.translate("PhysicalResource_Label_Limit")}: ${resource.limit}`,
            class: "underlined w3-large"
        }, content);

        let inputQuantity = new NumberInput();
        inputQuantity.setPlaces(2);
        inputQuantity.setMaxRange(resource.limit);
        inputQuantity.setMinRange(0);        
        inputQuantity.setValue(resource.quantity);
        inputQuantity.setLabel(this.translate("General_Label_Quantity"));
        inputQuantity.placeAt(content);
        this.UiModder.domClass.add(inputQuantity.domNode, "w3-col s6 m3");

        dlg.show(content,
            `${this.translate("General_Label_Resource")}: ${resource.description}`,
            null,
            null,
            "ok",
            (res) => {
                if (res === 1) {
                    let value = inputQuantity.getValue()

                    if (!value) {
                        this.showToast(this.translate("General_Error_InvalidData"), "fas fa-exclamation-triangle");
                        return;
                    }
                    this.modifyResource(value, rowGroup);
                    dlg.close();
                }
            },
            {
                keepOpen: true,
                closeOnEnter: false,
                size: "smaller"
            }
        )
    }
    private modifyResource(quantity: number, rowGr: StaticTable.StaticTableRowGroup<PhysicalResourceEntry>) {

        let entry = rowGr.entity;
        let resource = this.selectedResources.filter(x => x.resourceID === entry.resourceID && x.assignmentID === entry.assignmentID)[0];

        resource.quantity = quantity;

        this.setAttributeValue("physicalResources", lang.clone(this.selectedResources));
        this.updateResourcesTable();
    }
    private _onChangePhysicalResources(): void {
        let value = this.inputPhysicalResources.getValue() as PhysicalResourceData;

        this.addNewEntry(value);

        this.inputPhysicalResources.setValue(null, true);
    }
    private addNewEntry(value: PhysicalResourceData) {

        if (value == null) return;

        let existingEntry = this.selectedResources.filter(x => x.resourceID === value.ID)[0];

        if (existingEntry && existingEntry.isDeleted !== true) {

            this.showToast({
                title: this.translate("MainCatalogsEditor_PhysicalResources_Toast_ExistInList"),
                message: `**${value.description}**  ${this.translate("MainCatalogsEditor_PhysicalResources_Toast_ExistInList_details")}`,
                messageIcon: "fas fa-info-circle",
                iconClass: "fas fa-info-circle"
            })
            return;
        }

        if (existingEntry && existingEntry.isDeleted === true) {

            existingEntry.isDeleted = false;
            this.setAttributeValue("physicalResources", lang.clone(this.selectedResources));
            this.updateResourcesTable();
            return;
        }

        let fakeEntry: PhysicalResourceEntry = {
            assignmentID: null,
            resourceID: value.ID,
            code: value.code,
            ref_resource_main_group: value.ref_resource_main_group,
            description: value.description,
            coloration: value.coloration,
            limit: value.quantity,
            quantity: 1
        }

        this.selectedResources.push(fakeEntry);
        this.setAttributeValue("physicalResources", lang.clone(this.selectedResources));

        this.updateResourcesTable();
    }
    private updateResourcesTable() {

        let selectedResources: Array<PhysicalResourceEntry> = lang.clone(this.getAttributeValue("physicalResources"));

        selectedResources?.length > 0 ? this.expanderPhysicalResources.setMarking(ExpandableSectionMarkings.hasContent) : this.expanderPhysicalResources.setMarking(ExpandableSectionMarkings.default);

        this.resourcesTable.setData(selectedResources);

        selectedResources?.forEach(s => {
            if (s.isDeleted === true) {
                this.disableNode(this.resourcesTable.getRowByKeyValue(s.assignmentID, "assignmentID").rows[0].node);
            }
        });
    }
    private removeResource(rowGr: StaticTable.StaticTableRowGroup<PhysicalResourceEntry>) {

        let entry = rowGr.entity;
        let deletedResource = this.selectedResources.filter(x => x.resourceID === entry.resourceID && x.assignmentID === entry.assignmentID)[0];

        if (entry.assignmentID == null) {

            this.selectedResources.splice(this.selectedResources.indexOf(deletedResource), 1);
        } else {

            deletedResource.isDeleted = true;
        }

        this.setAttributeValue("physicalResources", lang.clone(this.selectedResources));
        this.updateResourcesTable();
    }
    private _setUpTable(response: { layouts: Array<any> }) {

        if (this.resourcesTable != null) this.resourcesTable.destroy();

        this.resourcesTable = new StaticTable();
        this.resourcesTable.placeAt(this.tableContainer);

        this.resourcesTable.setLayout(response.layouts[0]);
        this.resourcesTable.addDefaultRowActionButton("delete", lang.hitch(this, this.removeResource));
        //this.positionsTable.addCustomRowActionButton("deleteService", lang.hitch(this, this.removeService), "fas fa-bin w3-large");

        this.resourcesTable.setRowClick(lang.hitch(this, this.setPhysicalResourceQuantity))

        this.resourcesTable.setCyAttribute("EvServiceEditorV2Table");

        this.updateResourcesTable();
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);


        on(this, "CatalogEntityData_Save", () => {
            this.input_Category.setValue(null, true);
        });

        this.entityClass = MainCatalogs_Classes.EvServices;
        // enums durchiterieren ist sch.... aber so gehts halbwegs.
        for (let svcType in EvService_Types) {

            let value: any = EvService_Types[svcType];

            if (!isNaN(value)) {
                this.input_Type.addOption(
                    value,
                    this.translations["service_type_" + value.toString()],
                    true);
            }
        }

        this.input_Type.on("change", lang.hitch(this, this._setInputTypeVisibility));



        this.input_Type.constructOptions();

        this.input_Price.setUnit("&#8364");
        this.input_Price.setPlaces(2);
        this.input_Price.setStep("0.01");

        this.inputPhysicalResources.addInlineButton(lang.hitch(this, this._onClick_OpenEvServicesSED));
        this.SEDconfigCallfunction = "Webtool_API_MainCatalogsEditor__SED_GetConfig";

        if (!this.hasFeature("MainCatalog/PhysicalResources") || !this.hasUserRole("MainCatalogsEditor_PhysicalResources")) this.hideNode(this.expanderPhysicalResources, true);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        if (this.isNew) {
            this.loadReferenceCatalogs();
        }
        if (this.hasFeature("MainCatalog/PhysicalResources") || this.hasUserRole("MainCatalogsEditor_PhysicalResources")) {
            this.RequestManager.callfunction(
                "Webtool__MainCatalogsEditor_GetPhysicalResourcesPositionsTable",
                null,
                lang.hitch(this, this._setUpTable),
                (err) => { this.showToast(err.Message) }
            )
        }        
    }
}

export default mdsWidget(EvServiceEditorV2);
